<template lang="pug">
  .login
    .container
      .row
        .col-lg-7
          // nplex logo
          .row
            .col
              img.nplex-logo(src='../assets/img/nplex_color.svg', alt='NPLEX logo')
            .col-7
          .row
            .col
              .body-2.nplex-description.mt-3
                | Across the country, 35 states rely on the National Precursor Log Exchange (NPLEx ®), a real-time electronic
                | logging and compliance system that tracks sales of over-the-counter (OTC) cold and allergy medications containing pseudoephedrine
                | (PSE), a precursor to the illegal drug methamphetamine.
          .row
            .col
              h3 Aiding law enforcement in preventing meth production
          .row.nplex-feature
            .col
              img.feature-icon.w-50.ml-auto.mt-2(src='../assets/img/bell.svg', alt='bell icon')
            .col-10
              .h7 GET REAL-TIME NOTIFICATIONS & LOCATE PERSONS OF INTEREST
              span.body-3
                | Real-time alerts notify law enforcement when persons of interest purchase or are blocked from
                | purchasing PSE. NPLEx also helps law enforcement search our secure site to locate known suspects.
          .row.nplex-feature
            .col
              img.feature-icon.w-50.ml-auto.mt-2(src='../assets/img/ring.svg', alt='ring icon')
            .col-10
              .h7 DETECT ILLEGAL PURCHASING RINGS
              span.body-3
                | NPLEx provides automated tools that enable law enforcement to proactively identify diverters and associated
                | persons leading to the meth cook.
          .row.nplex-feature
            .col
              img.feature-icon.w-50.ml-auto.mt-2(src='../assets/img/monitoring.svg', alt='monitoring icon')
            .col-10
              .h7 REAL-TIME MONITORING BETWEEN SELECTED STORES
              span.body-3
                | NPLEx Store Feed allows up to 5 stores to be monitored by law enforcement in real time to help
                | them identify suspicious activity and intervene appropriately.
        .col-lg
          .login-panel.px-5.pt-5.pb-5
            h2 Secure Log In
            form.pt-3(
              v-on:submit.prevent='attemptLogin'
              autocomplete="off"
            )
              .form-group
                label.body-2(for='username') Username
                input#username.form-control(v-model='username', type='text', name='username', aria-describedby='forgotUsername')
                .text-right
                  router-link#forgotUsername.body-3(to='/forgot_username') Forgot username?
              .form-group
                label.body-2(for='password') Password
                input#password.form-control(v-model='password', type='password', name='password', aria-describedby='forgotPassword')
                .text-right
                  router-link#forgotPassword.body-3(to='/forgot_password') Forgot password?
              button.btn.btn-primary.w-100.mt-5.mb-4 Login
              .text-center
                router-link.h4.create-account-link(to='/registration') Create an Account
</template>

<script>
import * as session from '@/lib/session'
import { globalError } from '@/lib/utils'
import get from 'lodash/get'

export default {
  name: 'Login',
  data: function() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    attemptLogin() {
      session
        .signIn(this.username, this.password)
        .then(() => {
          let redirect = this.$route.query.redirect
          // If we include a redirect parameter for post-login, redirect to that page instead
          if (redirect) {
            this.$router.push({ path: redirect })
            window.localStorage.removeItem('redirect-url')
          } else {
            this.$router.push({ name: 'dashboard' })
          }
        })
        .catch(err => {
          if (err.response.status !== 462) globalError(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';
@import '../assets/styles/breakpoints';
.login {
  background: #efeee6;
  padding-top: 5rem;
  height:100%;
  padding-bottom: 5rem;
}

.nplex-logo {
  width: 200px;
}

.nplex-description {
  margin-bottom: 2rem;
}

.nplex-feature {
  margin-top: 1.3rem;
}

.login-panel {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.15);
}

.create-account-link {
  color: $primary;
}

.feature-icon {
  display: block;
}

@media (max-width: $bp-lg) {
  .login-panel {
    margin-top: 2rem;
    padding-bottom: 2rem;
  }
}
</style>
